var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16782 4.8745L5.00001 1.16991L0.832187 4.8745C0.625796 5.05796 0.30976 5.03937 0.126301 4.83298C-0.0571583 4.6266 -0.0385679 4.31058 0.167823 4.12712L4.66782 0.127267C4.85727 -0.0411204 5.14274 -0.0411204 5.33219 0.127267L9.83219 4.12712C10.0386 4.31058 10.0572 4.6266 9.87371 4.83298C9.69025 5.03937 9.37422 5.05796 9.16782 4.8745Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.126301 11.1684C0.30976 10.962 0.625796 10.9434 0.832187 11.1269L5.00001 14.8315L9.16782 11.1269C9.37422 10.9434 9.69025 10.962 9.87371 11.1684C10.0572 11.3748 10.0386 11.6908 9.83219 11.8743L5.33219 15.8741C5.14274 16.0425 4.85727 16.0425 4.66782 15.8741L0.167823 11.8743C-0.0385679 11.6908 -0.0571583 11.3748 0.126301 11.1684Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.3c747d1982cc4d7c27accc32e5c494a4.svg";
export { ForwardRef as ReactComponent };